/* tslint:disable */
/* eslint-disable */
/**
 * Wear Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * @type PutRegionsRegionidExcludedRequest
 */
export type PutRegionsRegionidExcludedRequest = RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto | RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto | RHIMAPOReportingWearManagementApiV1ModelsRegionUpdateBaseDto | RHIMAPOReportingWearManagementApiV1ModelsRegionUpdateRequestDto;

/**
 * @type PutRegionsRegionidRequest
 * see RHIM.APO.Common.Data.Reporting.Region
 */
export type PutRegionsRegionidRequest = RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto | RHIMAPOReportingWearManagementApiV1ModelsRegionUpdateRequestDto;


export const RHIMAPOCommonDataReportingHostingMode = {
    AmlWithAksFallback: 'AMLWithAKSFallback',
    Aml: 'AML',
    Aks: 'AKS',
    Disabled: 'Disabled',
} as const;

export type RHIMAPOCommonDataReportingHostingMode = typeof RHIMAPOCommonDataReportingHostingMode[keyof typeof RHIMAPOCommonDataReportingHostingMode];


export interface RHIMAPOReportingWearManagementApiV1ModelsAbsoluteThresholdDto {
    'threshold': number;
    'severity': RHIMContractsMaintenanceTaskSeverity;
    'maintenanceTask'?: string | null;
    'thresholdType': RHIMContractsThresholdType;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsAbsoluteThresholdRequestDto {
    'threshold': number;
    'severity': RHIMContractsMaintenanceTaskSeverity;
    'maintenanceTask'?: string | null;
    'thresholdType': RHIMContractsThresholdType;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsBOFAccumulatedValue {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFBofReportModelDto {
    'campaignNr'?: string | null;
    'customer'?: string | null;
    'laserData'?: RHIMAPOReportingWearManagementApiV1ModelsBOFLaserData | null;
    'predictionUTCTimestamp': string;
    'processData'?: RHIMAPOReportingWearManagementApiV1ModelsBOFProcessData | null;
    'reportData'?: RHIMAPOReportingWearManagementApiV1ModelsBOFReportData | null;
    'schemaVersion'?: string | null;
    'vessel': number;
    'vesselId'?: string | null;
    'vesselType'?: string | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFHotSpot {
    'averageWearSpeed'?: number | null;
    'delta_kpis'?: { [key: string]: any | null; } | null;
    'heat_range_delta_kpis'?: { [key: string]: any | null; } | null;
    'heat_range_kpis'?: { [key: string]: any | null; } | null;
    'id'?: string | null;
    'kpis'?: { [key: string]: any | null; } | null;
    'measuredPoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFMeasuredPoint> | null;
    'modelName'?: string | null;
    'name'?: string | null;
    'parameters'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFParameter> | null;
    'predictedLifetime': number;
    'predictedPoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFPredictedPoint> | null;
    'remainingHeats': number;
    'standardCampaign'?: RHIMAPOReportingWearManagementApiV1ModelsBOFStandardCampaign | null;
    'targetLifetimePoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFTargetLifetimePoint> | null;
    'threshold': number;
    'univariatePredictedLifetime'?: number | null;
    'univariatePredictedLifetimeOutlook'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFUnivariatePredictedLifetimeOutlook> | null;
    'univariatePredictedPoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFUnivariatePredictedPoint> | null;
    'univariateRemainingHeats'?: number | null;
    'wallplotDefinition'?: RHIMAPOReportingWearManagementApiV1ModelsBOFWallplotDefinition | null;
    'displayName'?: string | null;
    'brickSuppliers'?: Array<string> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFLaserData {
    'heatsSinceLastMeasurement'?: number | null;
    'lastHeat'?: number | null;
    'metaData'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFMetaDatum> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFMeasuredPoint {
    'type'?: string | null;
    'values'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFValue> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFMetaDatum {
    'heatNr': number;
    'heatUTCTimestamp': string;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFParameter {
    'impact': number;
    'name'?: string | null;
    'parameterName'?: string | null;
    'isShortlisted': boolean;
    'isComputed': boolean;
    'hasModelImpact': boolean;
    'unit'?: string | null;
    'currentValue'?: number | null;
    'historicValues'?: Array<number> | null;
    'rangeMin'?: number | null;
    'rangeMax'?: number | null;
    'rangeInnerLimit'?: number | null;
    'rangeOuterLimit'?: number | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFPoint {
    'value'?: number | null;
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFPredictedAccumulatedValue {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFPredictedPoint {
    'error'?: number | null;
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFProcessData {
    'firstHeatUTCTimestamp'?: string | null;
    'lastHeat': number;
    'lastHeatUTCTimestamp': string;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFProcessParameter {
    'accumulatedValues'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFAccumulatedValue> | null;
    'forecastRate'?: number | null;
    'modelName'?: string | null;
    'name'?: string | null;
    'predictedAccumulatedValues'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFPredictedAccumulatedValue> | null;
    'predictedLifetime': number;
    'remainingHeats': number;
    'threshold': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFReportData {
    'hotSpots'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFHotSpot> | null;
    'processParameters'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFProcessParameter> | null;
    'wallplot'?: RHIMAPOReportingWearManagementApiV1ModelsBOFWallplot | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFStandardCampaign {
    'lower_threshold'?: Array<any> | null;
    'standard'?: Array<any> | null;
    'upper_threshold'?: Array<any> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFTargetLifetimePoint {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFUnivariatePredictedLifetimeOutlook {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFUnivariatePredictedPoint {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFValue {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFWallplot {
    'points'?: Array<RHIMAPOReportingWearManagementApiV1ModelsBOFPoint> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsBOFWallplotDefinition {
    'xMax': number;
    'xMin': number;
    'yMax': number;
    'yMin': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelDto {
    'id': string;
    'vesselId': string;
    'campaign': number;
    'schemaVersion'?: string | null;
    'scoringTimestamp': string;
    'zones'?: Array<RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelZoneDto> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelHistoricDataPointDto {
    'timeStamp': string;
    'predictedValue'?: number | null;
    'measuredValue'?: number | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelPredictedDataPointDto {
    'timeStamp': string;
    'value'?: number | null;
    'predictionConfidence'?: number | null;
    'trend'?: number | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelZoneDto {
    'zoneId'?: string | null;
    'zoneName'?: string | null;
    'startingRunningMeter': number;
    'endingRunningMeter': number;
    'minTemperature': number;
    'maxTemperature': number;
    'thresholdTemperature'?: number | null;
    'predictionWindow': number;
    'predictions'?: Array<RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelPredictedDataPointDto> | null;
    'historicPredictionWindow': number;
    'historicRMSE'?: number | null;
    'historicData'?: Array<RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelHistoricDataPointDto> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCampaignOverviewDto {
    /**
     * The Id of a campaign. A value of null indicates that there are other entities that are not assigned to a campaign.
     */
    'id'?: number | null;
    /**
     * The relation to a Vessel.
     */
    'vesselId': string;
    /**
     * The text to be displayed for a campaign.
     */
    'displayText': string;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneDto {
    'label': string;
    'rmFrom': number;
    'rmTo': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto {
    'displayName': string;
    'startDate': string;
    'isEnabled': boolean;
    'crkZones'?: Array<RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneDto> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCrkZoneDto {
    'label'?: string | null;
    'rmFrom': number;
    'rmTo': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto {
    'id': string;
    'displayName'?: string | null;
    'startDate': string;
    'isEnabled': boolean;
    'crkZones'?: Array<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneDto> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto {
    /**
     * The vessel type for which this model selection is used
     */
    'vesselType': string;
    /**
     * The id of the customer whose data science model is to be used.  Can be null if HostingMode is Disabled as no data science model is needed then.
     */
    'targetCustomerId'?: string | null;
    /**
     * The hostingMode decides which type of hosting should be used.  If it is set to RHIM.APO.Common.Data.Reporting.HostingMode.Disabled no model is used and the operation ends.
     */
    'hostingMode': RHIMAPOCommonDataReportingHostingMode;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto {
    'displayName'?: string | null;
    'shortName'?: string | null;
    'regionLocation': RHIMContractsRegionLocation;
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    'area': Array<RHIMContractsRegionPoint>;
    'vesselId': string;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto {
    /**
     * The type of vessel for this orientation label
     */
    'vesselType': string;
    /**
     * A list of thresholds and colors
     */
    'angleAndDescription': Array<RHIMHMDCustomerManagementContractsV1VesselOrientationLabelDto>;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsPredictionOverviewDto {
    /**
     * The Id of the prediction
     */
    'id': string;
    /**
     * The Id of the vessel to which this prediction is assigned.
     */
    'vesselId': string;
    /**
     * The Id of the campaign.
     */
    'campaign': number;
    /**
     * The date, time and timezone of the prediction. Could be empty.
     */
    'scoringTimestamp': string;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHAccumulatedValue {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHAll {
    'campaign_max_heat'?: string | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHBestCampaign {
    'all'?: RHIMAPOReportingWearManagementApiV1ModelsRHAll | null;
    'recent'?: RHIMAPOReportingWearManagementApiV1ModelsRHRecent | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHBoxParameter {
    'name'?: string | null;
    'value': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHCustomArea {
    'box_parameters'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHBoxParameter> | null;
    'lower_vessel_number': number;
    'start_date': string;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHHotSpot {
    'forecastRate'?: number | null;
    'measuredPoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHMeasuredPoint> | null;
    'modelName'?: string | null;
    'modelPredictions'?: Array<any> | null;
    'name'?: string | null;
    'parameters'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHParameter> | null;
    'predictedLifetime': number;
    'predictedPoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHPredictedPoint> | null;
    'remainingHeats': number;
    'standardCampaign'?: RHIMAPOReportingWearManagementApiV1ModelsRHStandardCampaign | null;
    'targetLifetimePoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHTargetLifetimePoint> | null;
    'threshold': number;
    'univariatePredictedLifetime'?: number | null;
    'univariatePredictedLifetimeOutlook'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHUnivariatePredictedLifetimeOutlook> | null;
    'univariatePredictedPoints'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHUnivariatePredictedPoint> | null;
    'univariateRemainingHeats'?: number | null;
    'displayName'?: string | null;
    'brickSuppliers'?: Array<string> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHLaserData {
    'metaData'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHMetaDatum> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHMeasuredPoint {
    'type'?: string | null;
    'values'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHValue> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHMetaDatum {
    'heatNr': number;
    'heatUTCTimestamp'?: string | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHParameter {
    'impact': number;
    'name'?: string | null;
    'parameterName'?: string | null;
    'isShortlisted': boolean;
    'isComputed': boolean;
    'hasModelImpact': boolean;
    'unit'?: string | null;
    'currentValue'?: number | null;
    'historicValues'?: Array<number> | null;
    'rangeMin'?: number | null;
    'rangeMax'?: number | null;
    'rangeInnerLimit'?: number | null;
    'rangeOuterLimit'?: number | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHPredictedAccumulatedValue {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHPredictedPoint {
    'error'?: number | null;
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHProcessData {
    'firstHeatUTCTimestamp'?: string | null;
    'lastHeat': number;
    'lastHeatUTCTimestamp': string;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHProcessParameter {
    'accumulatedValues'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHAccumulatedValue> | null;
    'forecastRate'?: number | null;
    'internalName'?: string | null;
    'modelName'?: string | null;
    'name'?: string | null;
    'predictedAccumulatedValues'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHPredictedAccumulatedValue> | null;
    'predictedLifetime': number;
    'remainingHeats': number;
    'threshold': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHRecent {
    'campaign_max_heat'?: string | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHReportData {
    /**
     * DANGER!! Keep this! DS is maintaining in two repositories the schemas. One is customer specific and one generic. If the schema is regenerated this part needs to stay
     */
    'custom_area'?: RHIMAPOReportingWearManagementApiV1ModelsRHCustomArea | null;
    'hotSpots'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHHotSpot> | null;
    'hotSpotsDiameter'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHHotSpot> | null;
    'processParameters'?: Array<RHIMAPOReportingWearManagementApiV1ModelsRHProcessParameter> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHRhReportModelDto {
    'bestCampaign'?: RHIMAPOReportingWearManagementApiV1ModelsRHBestCampaign | null;
    'campaignNr': number;
    'customer'?: string | null;
    'laserData'?: RHIMAPOReportingWearManagementApiV1ModelsRHLaserData | null;
    'lowerVesselId'?: string | null;
    'predictionUTCTimestamp': string;
    'processData'?: RHIMAPOReportingWearManagementApiV1ModelsRHProcessData | null;
    'reportData'?: RHIMAPOReportingWearManagementApiV1ModelsRHReportData | null;
    'schemaVersion'?: string | null;
    'vessel': number;
    'vesselId'?: string | null;
    'vesselType'?: string | null;
    'campaignDisplayText'?: string | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHStandardCampaign {
    'lower_threshold'?: Array<any> | null;
    'standard'?: Array<any> | null;
    'upper_threshold'?: Array<any> | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHTargetLifetimePoint {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHUnivariatePredictedLifetimeOutlook {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHUnivariatePredictedPoint {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRHValue {
    'x': number;
    'y': number;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto {
    'displayName'?: string | null;
    'shortName'?: string | null;
    'regionLocation': RHIMContractsRegionLocation;
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    'area': Array<RHIMContractsRegionPoint>;
    /**
     * @deprecated
     */
    'order': number;
    /**
     * @deprecated
     */
    'name'?: string | null;
    'tags': Array<RHIMContractsRegionTag>;
    'thresholdWearCurves'?: Array<RHIMAPOReportingWearManagementApiV1ModelsThresholdWearCurveRequestDto> | null;
    'absoluteThresholds'?: Array<RHIMAPOReportingWearManagementApiV1ModelsAbsoluteThresholdRequestDto> | null;
    'vesselId': string;
}


/**
 * see RHIM.APO.Common.Data.Reporting.Region
 */
export interface RHIMAPOReportingWearManagementApiV1ModelsRegionDto {
    'id': string;
    'vesselId': string;
    /**
     * @deprecated
     */
    'order': number;
    'name'?: string | null;
    'displayName'?: string | null;
    'shortName'?: string | null;
    'regionLocation': RHIMContractsRegionLocation;
    'tags'?: Array<RHIMContractsRegionTag> | null;
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    'area'?: Array<RHIMContractsRegionPoint> | null;
    'thresholdWearCurves'?: Array<RHIMAPOReportingWearManagementApiV1ModelsThresholdWearCurveDto> | null;
    'absoluteThresholds'?: Array<RHIMAPOReportingWearManagementApiV1ModelsAbsoluteThresholdDto> | null;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsRegionUpdateBaseDto {
    'displayName'?: string | null;
    'shortName'?: string | null;
    'regionLocation': RHIMContractsRegionLocation;
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    'area': Array<RHIMContractsRegionPoint>;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsRegionUpdateRequestDto {
    'displayName'?: string | null;
    'shortName'?: string | null;
    'regionLocation': RHIMContractsRegionLocation;
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    'area': Array<RHIMContractsRegionPoint>;
    /**
     * @deprecated
     */
    'order': number;
    /**
     * @deprecated
     */
    'name'?: string | null;
    'tags': Array<RHIMContractsRegionTag>;
    'thresholdWearCurves'?: Array<RHIMAPOReportingWearManagementApiV1ModelsThresholdWearCurveRequestDto> | null;
    'absoluteThresholds'?: Array<RHIMAPOReportingWearManagementApiV1ModelsAbsoluteThresholdRequestDto> | null;
}


/**
 * see RHIM.APO.Common.Data.Reporting.ThresholdWearCurve
 */
export interface RHIMAPOReportingWearManagementApiV1ModelsThresholdWearCurveDto {
    'relativeInitialLiningThickness': number;
    'relativeLiningThicknessAtExpectedLifetime': number;
    'curveBendingFactor': number;
    'severity': RHIMContractsMaintenanceTaskSeverity;
    'maintenanceTask'?: string | null;
    'wearCurveType': RHIMContractsThresholdType;
}


/**
 * see RHIM.APO.Common.Data.Reporting.ThresholdWearCurve
 */
export interface RHIMAPOReportingWearManagementApiV1ModelsThresholdWearCurveRequestDto {
    'relativeInitialLiningThickness': number;
    'relativeLiningThicknessAtExpectedLifetime': number;
    'curveBendingFactor': number;
    'severity': RHIMContractsMaintenanceTaskSeverity;
    'maintenanceTask'?: string | null;
    'wearCurveType': RHIMContractsThresholdType;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto {
    /**
     * Id of the vessel the functional product belongs to
     */
    'vesselId': string;
    /**
     * Name of the functional product  Unique per Vessel
     */
    'name': string;
    /**
     * The type of this functional product
     */
    'type': RHIMContractsFunctionalProductType;
    /**
     * Part of the vessel in which this functional product is located
     */
    'regionLocation': RHIMContractsRegionLocation;
    'area': RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDtoArea;
    /**
     * The tilt angle of the product on the vessel
     */
    'tiltAngle': number;
}


/**
 * @type RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDtoArea
 * The representation of the geometry of the functional product
 */
export type RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDtoArea = RHIMHMDCustomerManagementContractsV1VesselCircleDto | RHIMHMDCustomerManagementContractsV1VesselCrkCylinderDto;

export interface RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto {
    /**
     * Name of the functional product  Unique per Vessel
     */
    'name': string;
    /**
     * The type of this functional product
     */
    'type': RHIMContractsFunctionalProductType;
    /**
     * Part of the vessel in which this functional product is located
     */
    'regionLocation': RHIMContractsRegionLocation;
    'area': RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDtoArea;
    /**
     * The tilt angle of the product on the vessel
     */
    'tiltAngle': number;
}


export interface RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionDto {
    'id': string;
    'customerId'?: string | null;
    'vesselType'?: string | null;
    'vesselId'?: string | null;
    'cron'?: string | null;
}
export interface RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto {
    'customerId'?: string | null;
    'vesselType'?: string | null;
    'vesselId'?: string | null;
    /**
     * This is the scheduling time for wearprediction in cron expression format. <br />  Notes: We only support cron expressions up to days and not above 7 days! <br />  This means that the third and fourth point of the expression <strong>must</strong> be `*`<br />  (This has to do with the deduplication window of azure service bus we use to reduce duplicate prediction request messages)<br />  Immediate trigger is expressed as every minute: `* * * * *`
     */
    'cron': string;
}

export const RHIMContractsColorScaleType = {
    Rbl: 'RBL',
    Wear: 'Wear',
} as const;

export type RHIMContractsColorScaleType = typeof RHIMContractsColorScaleType[keyof typeof RHIMContractsColorScaleType];



export const RHIMContractsCoordinateSystem2D = {
    Xy: 'XY',
    RTheta: 'RTheta',
    ThetaZ: 'ThetaZ',
} as const;

export type RHIMContractsCoordinateSystem2D = typeof RHIMContractsCoordinateSystem2D[keyof typeof RHIMContractsCoordinateSystem2D];



export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsFunctionalProductType = {
    Taphole: 'Taphole',
    PurgePlug: 'PurgePlug',
    Trunnion: 'Trunnion',
    Tyre: 'Tyre',
    Drive: 'Drive',
} as const;

export type RHIMContractsFunctionalProductType = typeof RHIMContractsFunctionalProductType[keyof typeof RHIMContractsFunctionalProductType];



export const RHIMContractsIndustry = {
    Steel: 'Steel',
    CementAndLime: 'CementAndLime',
    Nfm: 'NFM',
    Eec: 'EEC',
    Glass: 'Glass',
    Foundry: 'Foundry',
    Minerals: 'Minerals',
    ProcessIndustries: 'ProcessIndustries',
    Internal: 'Internal',
} as const;

export type RHIMContractsIndustry = typeof RHIMContractsIndustry[keyof typeof RHIMContractsIndustry];



export const RHIMContractsMaintenanceTaskSeverity = {
    None: 'None',
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
} as const;

export type RHIMContractsMaintenanceTaskSeverity = typeof RHIMContractsMaintenanceTaskSeverity[keyof typeof RHIMContractsMaintenanceTaskSeverity];



export const RHIMContractsRegionLocation = {
    Bottom: 'Bottom',
    Barrel: 'Barrel',
    Cone: 'Cone',
    ThroatIn: 'ThroatIn',
    ThroatOut: 'ThroatOut',
    Side0: 'Side0',
    Side1: 'Side1',
    Side2: 'Side2',
    Side3: 'Side3',
} as const;

export type RHIMContractsRegionLocation = typeof RHIMContractsRegionLocation[keyof typeof RHIMContractsRegionLocation];


export interface RHIMContractsRegionPoint {
    'r': number | null;
    'theta': number | null;
    'z': number | null;
    'x': number | null;
    'y': number | null;
}

export const RHIMContractsRegionTag = {
    Calculation: 'Calculation',
    WearPredictions: 'WearPredictions',
} as const;

export type RHIMContractsRegionTag = typeof RHIMContractsRegionTag[keyof typeof RHIMContractsRegionTag];



export const RHIMContractsThresholdType = {
    Target: 'Target',
    Lower: 'Lower',
    LowerPlotBoundary: 'LowerPlotBoundary',
    Critical: 'Critical',
    UpperPlotBoundary: 'UpperPlotBoundary',
    Upper: 'Upper',
} as const;

export type RHIMContractsThresholdType = typeof RHIMContractsThresholdType[keyof typeof RHIMContractsThresholdType];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
    Cco: 'CCO',
    Ccy: 'CCY',
    Cca: 'CCA',
    Tun: 'TUN',
    Pcg: 'PCG',
    Hof: 'HOF',
    Anf: 'ANF',
    Maf: 'MAF',
    Tif: 'TIF',
    Shf: 'SHF',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];


export interface RHIMHMDCustomerManagementContractsV1VesselCircleDto {
    'circleRadius': number;
    'midPoint': RHIMContractsRegionPoint;
}
export interface RHIMHMDCustomerManagementContractsV1VesselColorscaleDto {
    'vesselType': string;
    'colorScaleType'?: RHIMContractsColorScaleType | null;
    'thresholdsAndColors': Array<RHIMHMDCustomerManagementContractsV1VesselThresholdAndColorDto>;
}


export interface RHIMHMDCustomerManagementContractsV1VesselCrkCylinderDto {
    'runningMeter': number;
    'width': number;
}
export interface RHIMHMDCustomerManagementContractsV1VesselOrientationLabelDto {
    'angle': number;
    'displayText': string;
}
export interface RHIMHMDCustomerManagementContractsV1VesselThresholdAndColorDto {
    'threshold': number;
    'color': string;
}
export interface RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto {
    'id': string;
    'vesselId': string;
    'name': string;
    'type': RHIMContractsFunctionalProductType;
    'regionLocation': RHIMContractsRegionLocation;
    'area': RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDtoArea;
    'tiltAngle': number;
}


/**
 * @type RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDtoArea
 */
export type RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDtoArea = RHIMHMDCustomerManagementContractsV1VesselCircleDto | RHIMHMDCustomerManagementContractsV1VesselCrkCylinderDto;


/**
 * ColorscalesApi - axios parameter creator
 */
export const ColorscalesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the colorscale for a customer and a specific vesseltype
         * @summary Deletes the colorscale for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteColorscalesCustomeridVesseltype: async (customerId: string, vesseltype: string, threshold?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteColorscalesCustomeridVesseltype', 'customerId', customerId)
            // verify required parameter 'vesseltype' is not null or undefined
            assertParamExists('deleteColorscalesCustomeridVesseltype', 'vesseltype', vesseltype)
            const localVarPath = `/Colorscales/{customerId}/{vesseltype}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesseltype}', encodeURIComponent(String(vesseltype)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the colorscale for a customer and a specific vesseltype
         * @summary Deletes the colorscale for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
         * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteColorscalesCustomeridVesseltypeColorscaletype: async (customerId: string, vesseltype: string, colorScaleType: string, threshold?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteColorscalesCustomeridVesseltypeColorscaletype', 'customerId', customerId)
            // verify required parameter 'vesseltype' is not null or undefined
            assertParamExists('deleteColorscalesCustomeridVesseltypeColorscaletype', 'vesseltype', vesseltype)
            // verify required parameter 'colorScaleType' is not null or undefined
            assertParamExists('deleteColorscalesCustomeridVesseltypeColorscaletype', 'colorScaleType', colorScaleType)
            const localVarPath = `/Colorscales/{customerId}/{vesseltype}/{colorScaleType}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesseltype}', encodeURIComponent(String(vesseltype)))
                .replace('{colorScaleType}', encodeURIComponent(String(colorScaleType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColorscalesCustomeridVesseltype: async (customerId: string, vesseltype: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getColorscalesCustomeridVesseltype', 'customerId', customerId)
            // verify required parameter 'vesseltype' is not null or undefined
            assertParamExists('getColorscalesCustomeridVesseltype', 'vesseltype', vesseltype)
            const localVarPath = `/Colorscales/{customerId}/{vesseltype}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesseltype}', encodeURIComponent(String(vesseltype)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColorscalesCustomeridVesseltypeColorscaletype: async (customerId: string, vesseltype: string, colorScaleType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getColorscalesCustomeridVesseltypeColorscaletype', 'customerId', customerId)
            // verify required parameter 'vesseltype' is not null or undefined
            assertParamExists('getColorscalesCustomeridVesseltypeColorscaletype', 'vesseltype', vesseltype)
            // verify required parameter 'colorScaleType' is not null or undefined
            assertParamExists('getColorscalesCustomeridVesseltypeColorscaletype', 'colorScaleType', colorScaleType)
            const localVarPath = `/Colorscales/{customerId}/{vesseltype}/{colorScaleType}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesseltype}', encodeURIComponent(String(vesseltype)))
                .replace('{colorScaleType}', encodeURIComponent(String(colorScaleType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @summary Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @param {string} customerId 
         * @param {RHIMHMDCustomerManagementContractsV1VesselColorscaleDto} [rHIMHMDCustomerManagementContractsV1VesselColorscaleDto] Contains the information for the new colorscale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putColorscalesCustomerid: async (customerId: string, rHIMHMDCustomerManagementContractsV1VesselColorscaleDto?: RHIMHMDCustomerManagementContractsV1VesselColorscaleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putColorscalesCustomerid', 'customerId', customerId)
            const localVarPath = `/Colorscales/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMHMDCustomerManagementContractsV1VesselColorscaleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ColorscalesApi - functional programming interface
 */
export const ColorscalesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ColorscalesApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the colorscale for a customer and a specific vesseltype
         * @summary Deletes the colorscale for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteColorscalesCustomeridVesseltype(customerId: string, vesseltype: string, threshold?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteColorscalesCustomeridVesseltype(customerId, vesseltype, threshold, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorscalesApi.deleteColorscalesCustomeridVesseltype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the colorscale for a customer and a specific vesseltype
         * @summary Deletes the colorscale for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
         * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteColorscalesCustomeridVesseltypeColorscaletype(customerId: string, vesseltype: string, colorScaleType: string, threshold?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteColorscalesCustomeridVesseltypeColorscaletype(customerId, vesseltype, colorScaleType, threshold, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorscalesApi.deleteColorscalesCustomeridVesseltypeColorscaletype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getColorscalesCustomeridVesseltype(customerId: string, vesseltype: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV1VesselColorscaleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getColorscalesCustomeridVesseltype(customerId, vesseltype, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorscalesApi.getColorscalesCustomeridVesseltype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getColorscalesCustomeridVesseltypeColorscaletype(customerId: string, vesseltype: string, colorScaleType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV1VesselColorscaleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getColorscalesCustomeridVesseltypeColorscaletype(customerId, vesseltype, colorScaleType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorscalesApi.getColorscalesCustomeridVesseltypeColorscaletype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @summary Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @param {string} customerId 
         * @param {RHIMHMDCustomerManagementContractsV1VesselColorscaleDto} [rHIMHMDCustomerManagementContractsV1VesselColorscaleDto] Contains the information for the new colorscale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putColorscalesCustomerid(customerId: string, rHIMHMDCustomerManagementContractsV1VesselColorscaleDto?: RHIMHMDCustomerManagementContractsV1VesselColorscaleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putColorscalesCustomerid(customerId, rHIMHMDCustomerManagementContractsV1VesselColorscaleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorscalesApi.putColorscalesCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ColorscalesApi - factory interface
 */
export const ColorscalesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ColorscalesApiFp(configuration)
    return {
        /**
         * Deletes the colorscale for a customer and a specific vesseltype
         * @summary Deletes the colorscale for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteColorscalesCustomeridVesseltype(customerId: string, vesseltype: string, threshold?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteColorscalesCustomeridVesseltype(customerId, vesseltype, threshold, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the colorscale for a customer and a specific vesseltype
         * @summary Deletes the colorscale for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
         * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteColorscalesCustomeridVesseltypeColorscaletype(customerId: string, vesseltype: string, colorScaleType: string, threshold?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteColorscalesCustomeridVesseltypeColorscaletype(customerId, vesseltype, colorScaleType, threshold, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColorscalesCustomeridVesseltype(customerId: string, vesseltype: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV1VesselColorscaleDto> {
            return localVarFp.getColorscalesCustomeridVesseltype(customerId, vesseltype, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
         * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
         * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
         * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColorscalesCustomeridVesseltypeColorscaletype(customerId: string, vesseltype: string, colorScaleType: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV1VesselColorscaleDto> {
            return localVarFp.getColorscalesCustomeridVesseltypeColorscaletype(customerId, vesseltype, colorScaleType, options).then((request) => request(axios, basePath));
        },
        /**
         * Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @summary Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @param {string} customerId 
         * @param {RHIMHMDCustomerManagementContractsV1VesselColorscaleDto} [rHIMHMDCustomerManagementContractsV1VesselColorscaleDto] Contains the information for the new colorscale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putColorscalesCustomerid(customerId: string, rHIMHMDCustomerManagementContractsV1VesselColorscaleDto?: RHIMHMDCustomerManagementContractsV1VesselColorscaleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putColorscalesCustomerid(customerId, rHIMHMDCustomerManagementContractsV1VesselColorscaleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ColorscalesApi - object-oriented interface
 */
export class ColorscalesApi extends BaseAPI {
    /**
     * Deletes the colorscale for a customer and a specific vesseltype
     * @summary Deletes the colorscale for a customer and a specific vesseltype
     * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
     * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
     * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteColorscalesCustomeridVesseltype(customerId: string, vesseltype: string, threshold?: number, options?: RawAxiosRequestConfig) {
        return ColorscalesApiFp(this.configuration).deleteColorscalesCustomeridVesseltype(customerId, vesseltype, threshold, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the colorscale for a customer and a specific vesseltype
     * @summary Deletes the colorscale for a customer and a specific vesseltype
     * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
     * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
     * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
     * @param {number} [threshold] Optional query paramater. If it is provided only the entry for the provideed threshold will be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteColorscalesCustomeridVesseltypeColorscaletype(customerId: string, vesseltype: string, colorScaleType: string, threshold?: number, options?: RawAxiosRequestConfig) {
        return ColorscalesApiFp(this.configuration).deleteColorscalesCustomeridVesseltypeColorscaletype(customerId, vesseltype, colorScaleType, threshold, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
     * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
     * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
     * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getColorscalesCustomeridVesseltype(customerId: string, vesseltype: string, options?: RawAxiosRequestConfig) {
        return ColorscalesApiFp(this.configuration).getColorscalesCustomeridVesseltype(customerId, vesseltype, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
     * @summary Retrieves colorscales for a customer and a specific vesseltype and colorscaletype
     * @param {string} customerId The Id from the customer from which the colorscales should be retrieved
     * @param {string} vesseltype The vesseltype from which the colorscales should be retrieved
     * @param {string} colorScaleType The type of the colorscale. If no type is provided RBL is used as a default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getColorscalesCustomeridVesseltypeColorscaletype(customerId: string, vesseltype: string, colorScaleType: string, options?: RawAxiosRequestConfig) {
        return ColorscalesApiFp(this.configuration).getColorscalesCustomeridVesseltypeColorscaletype(customerId, vesseltype, colorScaleType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
     * @summary Upserts the new colorscale for a customer. If there was an old colorscale for the customer with the provided vesseltype it will be deleted before the new one is created.
     * @param {string} customerId 
     * @param {RHIMHMDCustomerManagementContractsV1VesselColorscaleDto} [rHIMHMDCustomerManagementContractsV1VesselColorscaleDto] Contains the information for the new colorscale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putColorscalesCustomerid(customerId: string, rHIMHMDCustomerManagementContractsV1VesselColorscaleDto?: RHIMHMDCustomerManagementContractsV1VesselColorscaleDto, options?: RawAxiosRequestConfig) {
        return ColorscalesApiFp(this.configuration).putColorscalesCustomerid(customerId, rHIMHMDCustomerManagementContractsV1VesselColorscaleDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CrkPredictionsApi - axios parameter creator
 */
export const CrkPredictionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
         * @summary Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
         * @param {string} vesselId The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionsCrkVesselidCampaigns: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getPredictionsCrkVesselidCampaigns', 'vesselId', vesselId)
            const localVarPath = `/predictions/crk/{vesselId}/campaigns`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of crk predictions for a vessel and a campaign.
         * @summary Returns a list of crk predictions for a vessel and a campaign.
         * @param {string} vesselId The Id of the vessel.
         * @param {number} campaign The campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionsCrkVesselidCampaignsCampaignPredictions: async (vesselId: string, campaign: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getPredictionsCrkVesselidCampaignsCampaignPredictions', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getPredictionsCrkVesselidCampaignsCampaignPredictions', 'campaign', campaign)
            const localVarPath = `/predictions/crk/{vesselId}/campaigns/{campaign}/predictions`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a CRK prediction.
         * @summary Gets a CRK prediction.
         * @param {string} vesselId The ID of the vessel
         * @param {string} predictionId The id of the prediction.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionsCrkVesselidPredictionid: async (vesselId: string, predictionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getPredictionsCrkVesselidPredictionid', 'vesselId', vesselId)
            // verify required parameter 'predictionId' is not null or undefined
            assertParamExists('getPredictionsCrkVesselidPredictionid', 'predictionId', predictionId)
            const localVarPath = `/predictions/crk/{vesselId}/{predictionId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{predictionId}', encodeURIComponent(String(predictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CrkPredictionsApi - functional programming interface
 */
export const CrkPredictionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CrkPredictionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
         * @summary Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
         * @param {string} vesselId The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPredictionsCrkVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsCampaignOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPredictionsCrkVesselidCampaigns(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkPredictionsApi.getPredictionsCrkVesselidCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of crk predictions for a vessel and a campaign.
         * @summary Returns a list of crk predictions for a vessel and a campaign.
         * @param {string} vesselId The Id of the vessel.
         * @param {number} campaign The campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPredictionsCrkVesselidCampaignsCampaignPredictions(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsPredictionOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPredictionsCrkVesselidCampaignsCampaignPredictions(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkPredictionsApi.getPredictionsCrkVesselidCampaignsCampaignPredictions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a CRK prediction.
         * @summary Gets a CRK prediction.
         * @param {string} vesselId The ID of the vessel
         * @param {string} predictionId The id of the prediction.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPredictionsCrkVesselidPredictionid(vesselId: string, predictionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPredictionsCrkVesselidPredictionid(vesselId, predictionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkPredictionsApi.getPredictionsCrkVesselidPredictionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CrkPredictionsApi - factory interface
 */
export const CrkPredictionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CrkPredictionsApiFp(configuration)
    return {
        /**
         * Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
         * @summary Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
         * @param {string} vesselId The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionsCrkVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsCampaignOverviewDto>> {
            return localVarFp.getPredictionsCrkVesselidCampaigns(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of crk predictions for a vessel and a campaign.
         * @summary Returns a list of crk predictions for a vessel and a campaign.
         * @param {string} vesselId The Id of the vessel.
         * @param {number} campaign The campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionsCrkVesselidCampaignsCampaignPredictions(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsPredictionOverviewDto>> {
            return localVarFp.getPredictionsCrkVesselidCampaignsCampaignPredictions(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a CRK prediction.
         * @summary Gets a CRK prediction.
         * @param {string} vesselId The ID of the vessel
         * @param {string} predictionId The id of the prediction.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionsCrkVesselidPredictionid(vesselId: string, predictionId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCRKCrkPredictionModelDto> {
            return localVarFp.getPredictionsCrkVesselidPredictionid(vesselId, predictionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CrkPredictionsApi - object-oriented interface
 */
export class CrkPredictionsApi extends BaseAPI {
    /**
     * Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
     * @summary Returns a list of campaigns which contain crk predictions that are available for the specified vessel.
     * @param {string} vesselId The Id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPredictionsCrkVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig) {
        return CrkPredictionsApiFp(this.configuration).getPredictionsCrkVesselidCampaigns(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of crk predictions for a vessel and a campaign.
     * @summary Returns a list of crk predictions for a vessel and a campaign.
     * @param {string} vesselId The Id of the vessel.
     * @param {number} campaign The campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPredictionsCrkVesselidCampaignsCampaignPredictions(vesselId: string, campaign: number, options?: RawAxiosRequestConfig) {
        return CrkPredictionsApiFp(this.configuration).getPredictionsCrkVesselidCampaignsCampaignPredictions(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a CRK prediction.
     * @summary Gets a CRK prediction.
     * @param {string} vesselId The ID of the vessel
     * @param {string} predictionId The id of the prediction.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPredictionsCrkVesselidPredictionid(vesselId: string, predictionId: string, options?: RawAxiosRequestConfig) {
        return CrkPredictionsApiFp(this.configuration).getPredictionsCrkVesselidPredictionid(vesselId, predictionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CrkZoneSetApi - axios parameter creator
 */
export const CrkZoneSetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a crk zone set
         * @summary Delete a crk zone set
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrkzonesetCrkzonesetid: async (crkZoneSetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crkZoneSetId' is not null or undefined
            assertParamExists('deleteCrkzonesetCrkzonesetid', 'crkZoneSetId', crkZoneSetId)
            const localVarPath = `/CrkZoneSet/{crkZoneSetId}`
                .replace('{crkZoneSetId}', encodeURIComponent(String(crkZoneSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a crk zone set by id
         * @summary Retrieves a crk zone set by id
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrkzonesetCrkzonesetid: async (crkZoneSetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crkZoneSetId' is not null or undefined
            assertParamExists('getCrkzonesetCrkzonesetid', 'crkZoneSetId', crkZoneSetId)
            const localVarPath = `/CrkZoneSet/{crkZoneSetId}`
                .replace('{crkZoneSetId}', encodeURIComponent(String(crkZoneSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all crk zone sets for a given vessel
         * @summary Retrieves all crk zone sets for a given vessel
         * @param {string} vesselId Id of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrkzonesetVesselsVesselidCrkzonesets: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getCrkzonesetVesselsVesselidCrkzonesets', 'vesselId', vesselId)
            const localVarPath = `/CrkZoneSet/vessels/{vesselId}/crkzonesets`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the active crk zone sets for a given vessel and timestamp
         * @summary Retrieves the active crk zone sets for a given vessel and timestamp
         * @param {string} vesselId Id of the vessel
         * @param {string} [timestamp] The timestamp for which the active crk zone set should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrkzonesetVesselsVesselidCrkzonesetsActive: async (vesselId: string, timestamp?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getCrkzonesetVesselsVesselidCrkzonesetsActive', 'vesselId', vesselId)
            const localVarPath = `/CrkZoneSet/vessels/{vesselId}/crkzonesets/active`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new crk zone set
         * @summary Create a new crk zone set
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCrkzonesetVesselsVesselidCrkzonesets: async (vesselId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postCrkzonesetVesselsVesselidCrkzonesets', 'vesselId', vesselId)
            const localVarPath = `/CrkZoneSet/vessels/{vesselId}/crkzonesets`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a crk zone set
         * @summary Update a crk zone set
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCrkzonesetCrkzonesetid: async (crkZoneSetId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crkZoneSetId' is not null or undefined
            assertParamExists('putCrkzonesetCrkzonesetid', 'crkZoneSetId', crkZoneSetId)
            const localVarPath = `/CrkZoneSet/{crkZoneSetId}`
                .replace('{crkZoneSetId}', encodeURIComponent(String(crkZoneSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CrkZoneSetApi - functional programming interface
 */
export const CrkZoneSetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CrkZoneSetApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a crk zone set
         * @summary Delete a crk zone set
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCrkzonesetCrkzonesetid(crkZoneSetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCrkzonesetCrkzonesetid(crkZoneSetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkZoneSetApi.deleteCrkzonesetCrkzonesetid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a crk zone set by id
         * @summary Retrieves a crk zone set by id
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrkzonesetCrkzonesetid(crkZoneSetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrkzonesetCrkzonesetid(crkZoneSetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkZoneSetApi.getCrkzonesetCrkzonesetid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all crk zone sets for a given vessel
         * @summary Retrieves all crk zone sets for a given vessel
         * @param {string} vesselId Id of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrkzonesetVesselsVesselidCrkzonesets(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrkzonesetVesselsVesselidCrkzonesets(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkZoneSetApi.getCrkzonesetVesselsVesselidCrkzonesets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the active crk zone sets for a given vessel and timestamp
         * @summary Retrieves the active crk zone sets for a given vessel and timestamp
         * @param {string} vesselId Id of the vessel
         * @param {string} [timestamp] The timestamp for which the active crk zone set should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrkzonesetVesselsVesselidCrkzonesetsActive(vesselId: string, timestamp?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrkzonesetVesselsVesselidCrkzonesetsActive(vesselId, timestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkZoneSetApi.getCrkzonesetVesselsVesselidCrkzonesetsActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new crk zone set
         * @summary Create a new crk zone set
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCrkzonesetVesselsVesselidCrkzonesets(vesselId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCrkzonesetVesselsVesselidCrkzonesets(vesselId, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkZoneSetApi.postCrkzonesetVesselsVesselidCrkzonesets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a crk zone set
         * @summary Update a crk zone set
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCrkzonesetCrkzonesetid(crkZoneSetId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCrkzonesetCrkzonesetid(crkZoneSetId, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrkZoneSetApi.putCrkzonesetCrkzonesetid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CrkZoneSetApi - factory interface
 */
export const CrkZoneSetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CrkZoneSetApiFp(configuration)
    return {
        /**
         * Delete a crk zone set
         * @summary Delete a crk zone set
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrkzonesetCrkzonesetid(crkZoneSetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCrkzonesetCrkzonesetid(crkZoneSetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a crk zone set by id
         * @summary Retrieves a crk zone set by id
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrkzonesetCrkzonesetid(crkZoneSetId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto> {
            return localVarFp.getCrkzonesetCrkzonesetid(crkZoneSetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all crk zone sets for a given vessel
         * @summary Retrieves all crk zone sets for a given vessel
         * @param {string} vesselId Id of the vessel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrkzonesetVesselsVesselidCrkzonesets(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto>> {
            return localVarFp.getCrkzonesetVesselsVesselidCrkzonesets(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the active crk zone sets for a given vessel and timestamp
         * @summary Retrieves the active crk zone sets for a given vessel and timestamp
         * @param {string} vesselId Id of the vessel
         * @param {string} [timestamp] The timestamp for which the active crk zone set should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrkzonesetVesselsVesselidCrkzonesetsActive(vesselId: string, timestamp?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto> {
            return localVarFp.getCrkzonesetVesselsVesselidCrkzonesetsActive(vesselId, timestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new crk zone set
         * @summary Create a new crk zone set
         * @param {string} vesselId Identifier of the vessel
         * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCrkzonesetVesselsVesselidCrkzonesets(vesselId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto> {
            return localVarFp.postCrkzonesetVesselsVesselidCrkzonesets(vesselId, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a crk zone set
         * @summary Update a crk zone set
         * @param {string} crkZoneSetId Identifier of the crk zone set
         * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCrkzonesetCrkzonesetid(crkZoneSetId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsCrkZoneSetDto> {
            return localVarFp.putCrkzonesetCrkzonesetid(crkZoneSetId, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CrkZoneSetApi - object-oriented interface
 */
export class CrkZoneSetApi extends BaseAPI {
    /**
     * Delete a crk zone set
     * @summary Delete a crk zone set
     * @param {string} crkZoneSetId Identifier of the crk zone set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCrkzonesetCrkzonesetid(crkZoneSetId: string, options?: RawAxiosRequestConfig) {
        return CrkZoneSetApiFp(this.configuration).deleteCrkzonesetCrkzonesetid(crkZoneSetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a crk zone set by id
     * @summary Retrieves a crk zone set by id
     * @param {string} crkZoneSetId Identifier of the crk zone set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCrkzonesetCrkzonesetid(crkZoneSetId: string, options?: RawAxiosRequestConfig) {
        return CrkZoneSetApiFp(this.configuration).getCrkzonesetCrkzonesetid(crkZoneSetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all crk zone sets for a given vessel
     * @summary Retrieves all crk zone sets for a given vessel
     * @param {string} vesselId Id of the vessel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCrkzonesetVesselsVesselidCrkzonesets(vesselId: string, options?: RawAxiosRequestConfig) {
        return CrkZoneSetApiFp(this.configuration).getCrkzonesetVesselsVesselidCrkzonesets(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the active crk zone sets for a given vessel and timestamp
     * @summary Retrieves the active crk zone sets for a given vessel and timestamp
     * @param {string} vesselId Id of the vessel
     * @param {string} [timestamp] The timestamp for which the active crk zone set should be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCrkzonesetVesselsVesselidCrkzonesetsActive(vesselId: string, timestamp?: string, options?: RawAxiosRequestConfig) {
        return CrkZoneSetApiFp(this.configuration).getCrkzonesetVesselsVesselidCrkzonesetsActive(vesselId, timestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new crk zone set
     * @summary Create a new crk zone set
     * @param {string} vesselId Identifier of the vessel
     * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCrkzonesetVesselsVesselidCrkzonesets(vesselId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options?: RawAxiosRequestConfig) {
        return CrkZoneSetApiFp(this.configuration).postCrkzonesetVesselsVesselidCrkzonesets(vesselId, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a crk zone set
     * @summary Update a crk zone set
     * @param {string} crkZoneSetId Identifier of the crk zone set
     * @param {RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto} [rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCrkzonesetCrkzonesetid(crkZoneSetId: string, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto?: RHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options?: RawAxiosRequestConfig) {
        return CrkZoneSetApiFp(this.configuration).putCrkzonesetCrkzonesetid(crkZoneSetId, rHIMAPOReportingWearManagementApiV1ModelsCreateOrUpdateCrkZoneSetDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataScienceModelSelectionsApi - axios parameter creator
 */
export const DataScienceModelSelectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves all data science model selections of a customer
         * @summary Retrieves all data science model selections of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridModelselections: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomersCustomeridModelselections', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/modelselections`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the data science model selections of the customer
         * @summary Set the data science model selections of the customer
         * @param {string} customerId Customer id to identify the customer
         * @param {Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>} [rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomeridModelselections: async (customerId: string, rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto?: Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putCustomersCustomeridModelselections', 'customerId', customerId)
            const localVarPath = `/customers/{customerId}/modelselections`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataScienceModelSelectionsApi - functional programming interface
 */
export const DataScienceModelSelectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataScienceModelSelectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves all data science model selections of a customer
         * @summary Retrieves all data science model selections of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersCustomeridModelselections(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersCustomeridModelselections(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataScienceModelSelectionsApi.getCustomersCustomeridModelselections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the data science model selections of the customer
         * @summary Set the data science model selections of the customer
         * @param {string} customerId Customer id to identify the customer
         * @param {Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>} [rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomersCustomeridModelselections(customerId: string, rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto?: Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomersCustomeridModelselections(customerId, rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataScienceModelSelectionsApi.putCustomersCustomeridModelselections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataScienceModelSelectionsApi - factory interface
 */
export const DataScienceModelSelectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataScienceModelSelectionsApiFp(configuration)
    return {
        /**
         * Retrieves all data science model selections of a customer
         * @summary Retrieves all data science model selections of a customer
         * @param {string} customerId Identifier of the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersCustomeridModelselections(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>> {
            return localVarFp.getCustomersCustomeridModelselections(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the data science model selections of the customer
         * @summary Set the data science model selections of the customer
         * @param {string} customerId Customer id to identify the customer
         * @param {Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>} [rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomersCustomeridModelselections(customerId: string, rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto?: Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putCustomersCustomeridModelselections(customerId, rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataScienceModelSelectionsApi - object-oriented interface
 */
export class DataScienceModelSelectionsApi extends BaseAPI {
    /**
     * Retrieves all data science model selections of a customer
     * @summary Retrieves all data science model selections of a customer
     * @param {string} customerId Identifier of the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomersCustomeridModelselections(customerId: string, options?: RawAxiosRequestConfig) {
        return DataScienceModelSelectionsApiFp(this.configuration).getCustomersCustomeridModelselections(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the data science model selections of the customer
     * @summary Set the data science model selections of the customer
     * @param {string} customerId Customer id to identify the customer
     * @param {Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>} [rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCustomersCustomeridModelselections(customerId: string, rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto?: Array<RHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto>, options?: RawAxiosRequestConfig) {
        return DataScienceModelSelectionsApiFp(this.configuration).putCustomersCustomeridModelselections(customerId, rHIMAPOReportingWearManagementApiV1ModelsDataScienceModelSelectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HostingModesApi - axios parameter creator
 */
export const HostingModesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all available hosting modes.
         * @summary Get all available hosting modes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostingmodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/HostingModes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HostingModesApi - functional programming interface
 */
export const HostingModesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HostingModesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all available hosting modes.
         * @summary Get all available hosting modes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHostingmodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOCommonDataReportingHostingMode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHostingmodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HostingModesApi.getHostingmodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HostingModesApi - factory interface
 */
export const HostingModesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HostingModesApiFp(configuration)
    return {
        /**
         * Get all available hosting modes.
         * @summary Get all available hosting modes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostingmodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOCommonDataReportingHostingMode>> {
            return localVarFp.getHostingmodes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HostingModesApi - object-oriented interface
 */
export class HostingModesApi extends BaseAPI {
    /**
     * Get all available hosting modes.
     * @summary Get all available hosting modes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHostingmodes(options?: RawAxiosRequestConfig) {
        return HostingModesApiFp(this.configuration).getHostingmodes(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrientationLabelApi - axios parameter creator
 */
export const OrientationLabelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the orientation label for a customer and a specific vesseltype
         * @summary Deletes the orientation label for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the orientation label should be deleted
         * @param {string} vesseltype The vesseltype from which the orientation labels should be deleted
         * @param {number} [degree] Optional query paramater. If it is provided only the entry for the provideed degree will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrientationlabelCustomeridVesseltype: async (customerId: string, vesseltype: string, degree?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteOrientationlabelCustomeridVesseltype', 'customerId', customerId)
            // verify required parameter 'vesseltype' is not null or undefined
            assertParamExists('deleteOrientationlabelCustomeridVesseltype', 'vesseltype', vesseltype)
            const localVarPath = `/OrientationLabel/{customerId}/{vesseltype}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesseltype}', encodeURIComponent(String(vesseltype)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (degree !== undefined) {
                localVarQueryParameter['degree'] = degree;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all orientation labels for a customer and a specific vesseltype
         * @summary Retrieves all orientation labels for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the orientation labels should be retrieved
         * @param {string} vesseltype The vesseltype from which the orientation labels should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrientationlabelCustomeridVesseltype: async (customerId: string, vesseltype: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getOrientationlabelCustomeridVesseltype', 'customerId', customerId)
            // verify required parameter 'vesseltype' is not null or undefined
            assertParamExists('getOrientationlabelCustomeridVesseltype', 'vesseltype', vesseltype)
            const localVarPath = `/OrientationLabel/{customerId}/{vesseltype}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesseltype}', encodeURIComponent(String(vesseltype)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @summary Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @param {string} customerId 
         * @param {RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto} [rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto] Contains the information for the new orientatioLabel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrientationlabelCustomerid: async (customerId: string, rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto?: RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putOrientationlabelCustomerid', 'customerId', customerId)
            const localVarPath = `/OrientationLabel/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrientationLabelApi - functional programming interface
 */
export const OrientationLabelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrientationLabelApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the orientation label for a customer and a specific vesseltype
         * @summary Deletes the orientation label for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the orientation label should be deleted
         * @param {string} vesseltype The vesseltype from which the orientation labels should be deleted
         * @param {number} [degree] Optional query paramater. If it is provided only the entry for the provideed degree will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrientationlabelCustomeridVesseltype(customerId: string, vesseltype: string, degree?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrientationlabelCustomeridVesseltype(customerId, vesseltype, degree, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrientationLabelApi.deleteOrientationlabelCustomeridVesseltype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all orientation labels for a customer and a specific vesseltype
         * @summary Retrieves all orientation labels for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the orientation labels should be retrieved
         * @param {string} vesseltype The vesseltype from which the orientation labels should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrientationlabelCustomeridVesseltype(customerId: string, vesseltype: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselOrientationLabelDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrientationlabelCustomeridVesseltype(customerId, vesseltype, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrientationLabelApi.getOrientationlabelCustomeridVesseltype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @summary Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @param {string} customerId 
         * @param {RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto} [rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto] Contains the information for the new orientatioLabel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOrientationlabelCustomerid(customerId: string, rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto?: RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOrientationlabelCustomerid(customerId, rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrientationLabelApi.putOrientationlabelCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrientationLabelApi - factory interface
 */
export const OrientationLabelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrientationLabelApiFp(configuration)
    return {
        /**
         * Deletes the orientation label for a customer and a specific vesseltype
         * @summary Deletes the orientation label for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the orientation label should be deleted
         * @param {string} vesseltype The vesseltype from which the orientation labels should be deleted
         * @param {number} [degree] Optional query paramater. If it is provided only the entry for the provideed degree will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrientationlabelCustomeridVesseltype(customerId: string, vesseltype: string, degree?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrientationlabelCustomeridVesseltype(customerId, vesseltype, degree, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all orientation labels for a customer and a specific vesseltype
         * @summary Retrieves all orientation labels for a customer and a specific vesseltype
         * @param {string} customerId The Id from the customer from which the orientation labels should be retrieved
         * @param {string} vesseltype The vesseltype from which the orientation labels should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrientationlabelCustomeridVesseltype(customerId: string, vesseltype: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselOrientationLabelDto>> {
            return localVarFp.getOrientationlabelCustomeridVesseltype(customerId, vesseltype, options).then((request) => request(axios, basePath));
        },
        /**
         * Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @summary Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
         * @param {string} customerId 
         * @param {RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto} [rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto] Contains the information for the new orientatioLabel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrientationlabelCustomerid(customerId: string, rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto?: RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putOrientationlabelCustomerid(customerId, rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrientationLabelApi - object-oriented interface
 */
export class OrientationLabelApi extends BaseAPI {
    /**
     * Deletes the orientation label for a customer and a specific vesseltype
     * @summary Deletes the orientation label for a customer and a specific vesseltype
     * @param {string} customerId The Id from the customer from which the orientation label should be deleted
     * @param {string} vesseltype The vesseltype from which the orientation labels should be deleted
     * @param {number} [degree] Optional query paramater. If it is provided only the entry for the provideed degree will be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrientationlabelCustomeridVesseltype(customerId: string, vesseltype: string, degree?: number, options?: RawAxiosRequestConfig) {
        return OrientationLabelApiFp(this.configuration).deleteOrientationlabelCustomeridVesseltype(customerId, vesseltype, degree, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all orientation labels for a customer and a specific vesseltype
     * @summary Retrieves all orientation labels for a customer and a specific vesseltype
     * @param {string} customerId The Id from the customer from which the orientation labels should be retrieved
     * @param {string} vesseltype The vesseltype from which the orientation labels should be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrientationlabelCustomeridVesseltype(customerId: string, vesseltype: string, options?: RawAxiosRequestConfig) {
        return OrientationLabelApiFp(this.configuration).getOrientationlabelCustomeridVesseltype(customerId, vesseltype, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
     * @summary Upserts the new orientation labels for a customer. If there was an old orientation label for the customer with the provided vesseltype it will be deleted before the new one is created.
     * @param {string} customerId 
     * @param {RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto} [rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto] Contains the information for the new orientatioLabel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putOrientationlabelCustomerid(customerId: string, rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto?: RHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, options?: RawAxiosRequestConfig) {
        return OrientationLabelApiFp(this.configuration).putOrientationlabelCustomerid(customerId, rHIMAPOReportingWearManagementApiV1ModelsOrientationLabelUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegionsApi - axios parameter creator
 */
export const RegionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a region by id
         * @summary Delete a region by id
         * @param {string} regionId Identifier of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegionsRegionid: async (regionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regionId' is not null or undefined
            assertParamExists('deleteRegionsRegionid', 'regionId', regionId)
            const localVarPath = `/Regions/{regionId}`
                .replace('{regionId}', encodeURIComponent(String(regionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all regions
         * @summary Retrieves all regions
         * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: async (vesselId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselId !== undefined) {
                localVarQueryParameter['vesselId'] = vesselId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all excluded regions
         * @summary Retrieves all excluded regions
         * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionsExcluded: async (vesselId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Regions/excluded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselId !== undefined) {
                localVarQueryParameter['vesselId'] = vesselId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a region by its id
         * @summary Retrieves a region by its id
         * @param {string} regionId Id of the region to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionsRegionid: async (regionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regionId' is not null or undefined
            assertParamExists('getRegionsRegionid', 'regionId', regionId)
            const localVarPath = `/Regions/{regionId}`
                .replace('{regionId}', encodeURIComponent(String(regionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves an excluded region by its id
         * @summary Retrieves an excluded region by its id
         * @param {string} regionId Id of the region to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionsRegionidExcluded: async (regionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regionId' is not null or undefined
            assertParamExists('getRegionsRegionidExcluded', 'regionId', regionId)
            const localVarPath = `/Regions/{regionId}/excluded`
                .replace('{regionId}', encodeURIComponent(String(regionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new region
         * @summary Creates a new region
         * @param {RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto] The json body which contains info about the new region.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRegions: async (rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new excluded region
         * @summary Creates a new excluded region
         * @param {RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto] The json body which contains info about the new region.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRegionsExcluded: async (rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Regions/excluded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a region by its id
         * @summary Updates a region by its id
         * @param {string} regionId Identifier of the region
         * @param {PutRegionsRegionidRequest} [putRegionsRegionidRequest] The updated region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRegionsRegionid: async (regionId: string, putRegionsRegionidRequest?: PutRegionsRegionidRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regionId' is not null or undefined
            assertParamExists('putRegionsRegionid', 'regionId', regionId)
            const localVarPath = `/Regions/{regionId}`
                .replace('{regionId}', encodeURIComponent(String(regionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putRegionsRegionidRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an excluded region by its id
         * @summary Updates an excluded region by its id
         * @param {string} regionId Identifier of the region
         * @param {PutRegionsRegionidExcludedRequest} [putRegionsRegionidExcludedRequest] The updated region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRegionsRegionidExcluded: async (regionId: string, putRegionsRegionidExcludedRequest?: PutRegionsRegionidExcludedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regionId' is not null or undefined
            assertParamExists('putRegionsRegionidExcluded', 'regionId', regionId)
            const localVarPath = `/Regions/{regionId}/excluded`
                .replace('{regionId}', encodeURIComponent(String(regionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putRegionsRegionidExcludedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegionsApi - functional programming interface
 */
export const RegionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a region by id
         * @summary Delete a region by id
         * @param {string} regionId Identifier of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegionsRegionid(regionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegionsRegionid(regionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.deleteRegionsRegionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all regions
         * @summary Retrieves all regions
         * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegions(vesselId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegions(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.getRegions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all excluded regions
         * @summary Retrieves all excluded regions
         * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegionsExcluded(vesselId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegionsExcluded(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.getRegionsExcluded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a region by its id
         * @summary Retrieves a region by its id
         * @param {string} regionId Id of the region to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegionsRegionid(regionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegionsRegionid(regionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.getRegionsRegionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves an excluded region by its id
         * @summary Retrieves an excluded region by its id
         * @param {string} regionId Id of the region to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegionsRegionidExcluded(regionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegionsRegionidExcluded(regionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.getRegionsRegionidExcluded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new region
         * @summary Creates a new region
         * @param {RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto] The json body which contains info about the new region.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRegions(rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRegions(rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.postRegions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new excluded region
         * @summary Creates a new excluded region
         * @param {RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto] The json body which contains info about the new region.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRegionsExcluded(rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRegionsExcluded(rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.postRegionsExcluded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a region by its id
         * @summary Updates a region by its id
         * @param {string} regionId Identifier of the region
         * @param {PutRegionsRegionidRequest} [putRegionsRegionidRequest] The updated region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putRegionsRegionid(regionId: string, putRegionsRegionidRequest?: PutRegionsRegionidRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putRegionsRegionid(regionId, putRegionsRegionidRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.putRegionsRegionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an excluded region by its id
         * @summary Updates an excluded region by its id
         * @param {string} regionId Identifier of the region
         * @param {PutRegionsRegionidExcludedRequest} [putRegionsRegionidExcludedRequest] The updated region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putRegionsRegionidExcluded(regionId: string, putRegionsRegionidExcludedRequest?: PutRegionsRegionidExcludedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putRegionsRegionidExcluded(regionId, putRegionsRegionidExcludedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsApi.putRegionsRegionidExcluded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RegionsApi - factory interface
 */
export const RegionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegionsApiFp(configuration)
    return {
        /**
         * Delete a region by id
         * @summary Delete a region by id
         * @param {string} regionId Identifier of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegionsRegionid(regionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRegionsRegionid(regionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all regions
         * @summary Retrieves all regions
         * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions(vesselId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>> {
            return localVarFp.getRegions(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all excluded regions
         * @summary Retrieves all excluded regions
         * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionsExcluded(vesselId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsRegionDto>> {
            return localVarFp.getRegionsExcluded(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a region by its id
         * @summary Retrieves a region by its id
         * @param {string} regionId Id of the region to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionsRegionid(regionId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto> {
            return localVarFp.getRegionsRegionid(regionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves an excluded region by its id
         * @summary Retrieves an excluded region by its id
         * @param {string} regionId Id of the region to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionsRegionidExcluded(regionId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto> {
            return localVarFp.getRegionsRegionidExcluded(regionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new region
         * @summary Creates a new region
         * @param {RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto] The json body which contains info about the new region.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRegions(rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto> {
            return localVarFp.postRegions(rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new excluded region
         * @summary Creates a new excluded region
         * @param {RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto] The json body which contains info about the new region.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRegionsExcluded(rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRegionDto> {
            return localVarFp.postRegionsExcluded(rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a region by its id
         * @summary Updates a region by its id
         * @param {string} regionId Identifier of the region
         * @param {PutRegionsRegionidRequest} [putRegionsRegionidRequest] The updated region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRegionsRegionid(regionId: string, putRegionsRegionidRequest?: PutRegionsRegionidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putRegionsRegionid(regionId, putRegionsRegionidRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an excluded region by its id
         * @summary Updates an excluded region by its id
         * @param {string} regionId Identifier of the region
         * @param {PutRegionsRegionidExcludedRequest} [putRegionsRegionidExcludedRequest] The updated region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRegionsRegionidExcluded(regionId: string, putRegionsRegionidExcludedRequest?: PutRegionsRegionidExcludedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putRegionsRegionidExcluded(regionId, putRegionsRegionidExcludedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegionsApi - object-oriented interface
 */
export class RegionsApi extends BaseAPI {
    /**
     * Delete a region by id
     * @summary Delete a region by id
     * @param {string} regionId Identifier of the region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteRegionsRegionid(regionId: string, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).deleteRegionsRegionid(regionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all regions
     * @summary Retrieves all regions
     * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRegions(vesselId?: string, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).getRegions(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all excluded regions
     * @summary Retrieves all excluded regions
     * @param {string} [vesselId] Id of the vessel for which the regions should be retrieved (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRegionsExcluded(vesselId?: string, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).getRegionsExcluded(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a region by its id
     * @summary Retrieves a region by its id
     * @param {string} regionId Id of the region to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRegionsRegionid(regionId: string, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).getRegionsRegionid(regionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves an excluded region by its id
     * @summary Retrieves an excluded region by its id
     * @param {string} regionId Id of the region to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRegionsRegionidExcluded(regionId: string, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).getRegionsRegionidExcluded(regionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new region
     * @summary Creates a new region
     * @param {RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto] The json body which contains info about the new region.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postRegions(rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).postRegions(rHIMAPOReportingWearManagementApiV1ModelsRegionCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new excluded region
     * @summary Creates a new excluded region
     * @param {RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto] The json body which contains info about the new region.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postRegionsExcluded(rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).postRegionsExcluded(rHIMAPOReportingWearManagementApiV1ModelsExcludedRegionCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a region by its id
     * @summary Updates a region by its id
     * @param {string} regionId Identifier of the region
     * @param {PutRegionsRegionidRequest} [putRegionsRegionidRequest] The updated region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putRegionsRegionid(regionId: string, putRegionsRegionidRequest?: PutRegionsRegionidRequest, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).putRegionsRegionid(regionId, putRegionsRegionidRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an excluded region by its id
     * @summary Updates an excluded region by its id
     * @param {string} regionId Identifier of the region
     * @param {PutRegionsRegionidExcludedRequest} [putRegionsRegionidExcludedRequest] The updated region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putRegionsRegionidExcluded(regionId: string, putRegionsRegionidExcludedRequest?: PutRegionsRegionidExcludedRequest, options?: RawAxiosRequestConfig) {
        return RegionsApiFp(this.configuration).putRegionsRegionidExcluded(regionId, putRegionsRegionidExcludedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VesselFunctionalProductsApi - axios parameter creator
 */
export const VesselFunctionalProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a functional product
         * @summary Deletes a functional product
         * @param {string} vesselFunctionalProductId The ID from the functional product to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVesselfunctionalproductsVesselfunctionalproductid: async (vesselFunctionalProductId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselFunctionalProductId' is not null or undefined
            assertParamExists('deleteVesselfunctionalproductsVesselfunctionalproductid', 'vesselFunctionalProductId', vesselFunctionalProductId)
            const localVarPath = `/VesselFunctionalProducts/{vesselFunctionalProductId}`
                .replace('{vesselFunctionalProductId}', encodeURIComponent(String(vesselFunctionalProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all functional products
         * @summary Retrieves all functional products
         * @param {string} [vesselId] Id of the vessel for which the functional products should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselfunctionalproducts: async (vesselId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/VesselFunctionalProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vesselId !== undefined) {
                localVarQueryParameter['vesselId'] = vesselId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all functional products for a vessel
         * @summary Retrieves all functional products for a vessel
         * @param {string} vesselId Id of the vessel for which the functional products should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselfunctionalproductsVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselfunctionalproductsVesselid', 'vesselId', vesselId)
            const localVarPath = `/VesselFunctionalProducts/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new functional product
         * @summary Creates a new functional product
         * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto] The json body which contains info about the functional product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselfunctionalproducts: async (rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/VesselFunctionalProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a functional product
         * @summary Updates a functional product
         * @param {string} vesselFunctionalProductId The ID from the functional product to update.
         * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto] The json body which contains info about the functional product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselfunctionalproductsVesselfunctionalproductid: async (vesselFunctionalProductId: string, rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselFunctionalProductId' is not null or undefined
            assertParamExists('putVesselfunctionalproductsVesselfunctionalproductid', 'vesselFunctionalProductId', vesselFunctionalProductId)
            const localVarPath = `/VesselFunctionalProducts/{vesselFunctionalProductId}`
                .replace('{vesselFunctionalProductId}', encodeURIComponent(String(vesselFunctionalProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VesselFunctionalProductsApi - functional programming interface
 */
export const VesselFunctionalProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VesselFunctionalProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a functional product
         * @summary Deletes a functional product
         * @param {string} vesselFunctionalProductId The ID from the functional product to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselFunctionalProductsApi.deleteVesselfunctionalproductsVesselfunctionalproductid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all functional products
         * @summary Retrieves all functional products
         * @param {string} [vesselId] Id of the vessel for which the functional products should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselfunctionalproducts(vesselId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselfunctionalproducts(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselFunctionalProductsApi.getVesselfunctionalproducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all functional products for a vessel
         * @summary Retrieves all functional products for a vessel
         * @param {string} vesselId Id of the vessel for which the functional products should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselfunctionalproductsVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselfunctionalproductsVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselFunctionalProductsApi.getVesselfunctionalproductsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new functional product
         * @summary Creates a new functional product
         * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto] The json body which contains info about the functional product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVesselfunctionalproducts(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVesselfunctionalproducts(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselFunctionalProductsApi.postVesselfunctionalproducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a functional product
         * @summary Updates a functional product
         * @param {string} vesselFunctionalProductId The ID from the functional product to update.
         * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto] The json body which contains info about the functional product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId: string, rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId, rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselFunctionalProductsApi.putVesselfunctionalproductsVesselfunctionalproductid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VesselFunctionalProductsApi - factory interface
 */
export const VesselFunctionalProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VesselFunctionalProductsApiFp(configuration)
    return {
        /**
         * Deletes a functional product
         * @summary Deletes a functional product
         * @param {string} vesselFunctionalProductId The ID from the functional product to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all functional products
         * @summary Retrieves all functional products
         * @param {string} [vesselId] Id of the vessel for which the functional products should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselfunctionalproducts(vesselId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto>> {
            return localVarFp.getVesselfunctionalproducts(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all functional products for a vessel
         * @summary Retrieves all functional products for a vessel
         * @param {string} vesselId Id of the vessel for which the functional products should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselfunctionalproductsVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto>> {
            return localVarFp.getVesselfunctionalproductsVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new functional product
         * @summary Creates a new functional product
         * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto] The json body which contains info about the functional product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselfunctionalproducts(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto> {
            return localVarFp.postVesselfunctionalproducts(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a functional product
         * @summary Updates a functional product
         * @param {string} vesselFunctionalProductId The ID from the functional product to update.
         * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto] The json body which contains info about the functional product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId: string, rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId, rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VesselFunctionalProductsApi - object-oriented interface
 */
export class VesselFunctionalProductsApi extends BaseAPI {
    /**
     * Deletes a functional product
     * @summary Deletes a functional product
     * @param {string} vesselFunctionalProductId The ID from the functional product to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId: string, options?: RawAxiosRequestConfig) {
        return VesselFunctionalProductsApiFp(this.configuration).deleteVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all functional products
     * @summary Retrieves all functional products
     * @param {string} [vesselId] Id of the vessel for which the functional products should be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselfunctionalproducts(vesselId?: string, options?: RawAxiosRequestConfig) {
        return VesselFunctionalProductsApiFp(this.configuration).getVesselfunctionalproducts(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all functional products for a vessel
     * @summary Retrieves all functional products for a vessel
     * @param {string} vesselId Id of the vessel for which the functional products should be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselfunctionalproductsVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselFunctionalProductsApiFp(this.configuration).getVesselfunctionalproductsVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new functional product
     * @summary Creates a new functional product
     * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto] The json body which contains info about the functional product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postVesselfunctionalproducts(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, options?: RawAxiosRequestConfig) {
        return VesselFunctionalProductsApiFp(this.configuration).postVesselfunctionalproducts(rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a functional product
     * @summary Updates a functional product
     * @param {string} vesselFunctionalProductId The ID from the functional product to update.
     * @param {RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto] The json body which contains info about the functional product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId: string, rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return VesselFunctionalProductsApiFp(this.configuration).putVesselfunctionalproductsVesselfunctionalproductid(vesselFunctionalProductId, rHIMAPOReportingWearManagementApiV1ModelsVesselFunctionalProductUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WearExplorerViewApi - axios parameter creator
 */
export const WearExplorerViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @summary Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @param {string} vesselId The ID of the vessel
         * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearexplorerviewVesselsBofVesselid: async (vesselId: string, campaign?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getWearexplorerviewVesselsBofVesselid', 'vesselId', vesselId)
            const localVarPath = `/WearExplorerView/vessels/bof/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @summary Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @param {string} vesselId The ID of the vessel
         * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearexplorerviewVesselsRhVesselid: async (vesselId: string, campaign?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getWearexplorerviewVesselsRhVesselid', 'vesselId', vesselId)
            const localVarPath = `/WearExplorerView/vessels/rh/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WearExplorerViewApi - functional programming interface
 */
export const WearExplorerViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WearExplorerViewApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @summary Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @param {string} vesselId The ID of the vessel
         * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWearexplorerviewVesselsBofVesselid(vesselId: string, campaign?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsBOFBofReportModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWearexplorerviewVesselsBofVesselid(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WearExplorerViewApi.getWearexplorerviewVesselsBofVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @summary Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @param {string} vesselId The ID of the vessel
         * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWearexplorerviewVesselsRhVesselid(vesselId: string, campaign?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRHRhReportModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWearexplorerviewVesselsRhVesselid(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WearExplorerViewApi.getWearexplorerviewVesselsRhVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WearExplorerViewApi - factory interface
 */
export const WearExplorerViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WearExplorerViewApiFp(configuration)
    return {
        /**
         * Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @summary Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @param {string} vesselId The ID of the vessel
         * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearexplorerviewVesselsBofVesselid(vesselId: string, campaign?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsBOFBofReportModelDto> {
            return localVarFp.getWearexplorerviewVesselsBofVesselid(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @summary Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
         * @param {string} vesselId The ID of the vessel
         * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearexplorerviewVesselsRhVesselid(vesselId: string, campaign?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsRHRhReportModelDto> {
            return localVarFp.getWearexplorerviewVesselsRhVesselid(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WearExplorerViewApi - object-oriented interface
 */
export class WearExplorerViewApi extends BaseAPI {
    /**
     * Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
     * @summary Gets the latest BOF prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
     * @param {string} vesselId The ID of the vessel
     * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWearexplorerviewVesselsBofVesselid(vesselId: string, campaign?: string, options?: RawAxiosRequestConfig) {
        return WearExplorerViewApiFp(this.configuration).getWearexplorerviewVesselsBofVesselid(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
     * @summary Gets the latest RH prediction json for a given set of parameters and maps it to a defined DTO.  Caution: This returns a huge object, swagger likely can\'t handle this because it tries to prettify output so consider using postman or directly the api in browser for testing
     * @param {string} vesselId The ID of the vessel
     * @param {string} [campaign] The campaign of the prediction. (This parameter is optional, if omitted the latest prediction will be taken)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWearexplorerviewVesselsRhVesselid(vesselId: string, campaign?: string, options?: RawAxiosRequestConfig) {
        return WearExplorerViewApiFp(this.configuration).getWearexplorerviewVesselsRhVesselid(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WearPredictionScheduleOptionsApi - axios parameter creator
 */
export const WearPredictionScheduleOptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a wearprediction schedule option by id
         * @summary Delete a wearprediction schedule option by id
         * @param {string} optionId Identifier of the schedule option
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWearpredictionscheduleoptionsOptionid: async (optionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('deleteWearpredictionscheduleoptionsOptionid', 'optionId', optionId)
            const localVarPath = `/WearPredictionScheduleOptions/{optionId}`
                .replace('{optionId}', encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all WearPredictionScheduleOptions
         * @summary Retrieves all WearPredictionScheduleOptions
         * @param {string} [customerId] Id of the customer for which the options should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearpredictionscheduleoptions: async (customerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/WearPredictionScheduleOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a WearPredictionScheduleOption by its id
         * @summary Retrieves a WearPredictionScheduleOption by its id
         * @param {string} optionId Id of the schedule option to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearpredictionscheduleoptionsOptionid: async (optionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('getWearpredictionscheduleoptionsOptionid', 'optionId', optionId)
            const localVarPath = `/WearPredictionScheduleOptions/{optionId}`
                .replace('{optionId}', encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a WearPredictionScheduleOption
         * @summary Creates a WearPredictionScheduleOption
         * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The json body which contains info about the new schedule option.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWearpredictionscheduleoptions: async (rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/WearPredictionScheduleOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a WearPredictionScheduleOption by its id
         * @summary Updates a WearPredictionScheduleOption by its id
         * @param {string} optionId Identifier of the schedule option
         * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The updated schedule option
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWearpredictionscheduleoptionsOptionid: async (optionId: string, rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('putWearpredictionscheduleoptionsOptionid', 'optionId', optionId)
            const localVarPath = `/WearPredictionScheduleOptions/{optionId}`
                .replace('{optionId}', encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WearPredictionScheduleOptionsApi - functional programming interface
 */
export const WearPredictionScheduleOptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WearPredictionScheduleOptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a wearprediction schedule option by id
         * @summary Delete a wearprediction schedule option by id
         * @param {string} optionId Identifier of the schedule option
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWearpredictionscheduleoptionsOptionid(optionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWearpredictionscheduleoptionsOptionid(optionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WearPredictionScheduleOptionsApi.deleteWearpredictionscheduleoptionsOptionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all WearPredictionScheduleOptions
         * @summary Retrieves all WearPredictionScheduleOptions
         * @param {string} [customerId] Id of the customer for which the options should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWearpredictionscheduleoptions(customerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWearpredictionscheduleoptions(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WearPredictionScheduleOptionsApi.getWearpredictionscheduleoptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a WearPredictionScheduleOption by its id
         * @summary Retrieves a WearPredictionScheduleOption by its id
         * @param {string} optionId Id of the schedule option to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWearpredictionscheduleoptionsOptionid(optionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWearpredictionscheduleoptionsOptionid(optionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WearPredictionScheduleOptionsApi.getWearpredictionscheduleoptionsOptionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a WearPredictionScheduleOption
         * @summary Creates a WearPredictionScheduleOption
         * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The json body which contains info about the new schedule option.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWearpredictionscheduleoptions(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWearpredictionscheduleoptions(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WearPredictionScheduleOptionsApi.postWearpredictionscheduleoptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a WearPredictionScheduleOption by its id
         * @summary Updates a WearPredictionScheduleOption by its id
         * @param {string} optionId Identifier of the schedule option
         * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The updated schedule option
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putWearpredictionscheduleoptionsOptionid(optionId: string, rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putWearpredictionscheduleoptionsOptionid(optionId, rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WearPredictionScheduleOptionsApi.putWearpredictionscheduleoptionsOptionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WearPredictionScheduleOptionsApi - factory interface
 */
export const WearPredictionScheduleOptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WearPredictionScheduleOptionsApiFp(configuration)
    return {
        /**
         * Delete a wearprediction schedule option by id
         * @summary Delete a wearprediction schedule option by id
         * @param {string} optionId Identifier of the schedule option
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWearpredictionscheduleoptionsOptionid(optionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWearpredictionscheduleoptionsOptionid(optionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all WearPredictionScheduleOptions
         * @summary Retrieves all WearPredictionScheduleOptions
         * @param {string} [customerId] Id of the customer for which the options should be retrieved (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearpredictionscheduleoptions(customerId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionDto>> {
            return localVarFp.getWearpredictionscheduleoptions(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a WearPredictionScheduleOption by its id
         * @summary Retrieves a WearPredictionScheduleOption by its id
         * @param {string} optionId Id of the schedule option to be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWearpredictionscheduleoptionsOptionid(optionId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionDto> {
            return localVarFp.getWearpredictionscheduleoptionsOptionid(optionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a WearPredictionScheduleOption
         * @summary Creates a WearPredictionScheduleOption
         * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The json body which contains info about the new schedule option.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWearpredictionscheduleoptions(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionDto> {
            return localVarFp.postWearpredictionscheduleoptions(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a WearPredictionScheduleOption by its id
         * @summary Updates a WearPredictionScheduleOption by its id
         * @param {string} optionId Identifier of the schedule option
         * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The updated schedule option
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWearpredictionscheduleoptionsOptionid(optionId: string, rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putWearpredictionscheduleoptionsOptionid(optionId, rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WearPredictionScheduleOptionsApi - object-oriented interface
 */
export class WearPredictionScheduleOptionsApi extends BaseAPI {
    /**
     * Delete a wearprediction schedule option by id
     * @summary Delete a wearprediction schedule option by id
     * @param {string} optionId Identifier of the schedule option
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWearpredictionscheduleoptionsOptionid(optionId: string, options?: RawAxiosRequestConfig) {
        return WearPredictionScheduleOptionsApiFp(this.configuration).deleteWearpredictionscheduleoptionsOptionid(optionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all WearPredictionScheduleOptions
     * @summary Retrieves all WearPredictionScheduleOptions
     * @param {string} [customerId] Id of the customer for which the options should be retrieved (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWearpredictionscheduleoptions(customerId?: string, options?: RawAxiosRequestConfig) {
        return WearPredictionScheduleOptionsApiFp(this.configuration).getWearpredictionscheduleoptions(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a WearPredictionScheduleOption by its id
     * @summary Retrieves a WearPredictionScheduleOption by its id
     * @param {string} optionId Id of the schedule option to be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWearpredictionscheduleoptionsOptionid(optionId: string, options?: RawAxiosRequestConfig) {
        return WearPredictionScheduleOptionsApiFp(this.configuration).getWearpredictionscheduleoptionsOptionid(optionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a WearPredictionScheduleOption
     * @summary Creates a WearPredictionScheduleOption
     * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The json body which contains info about the new schedule option.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postWearpredictionscheduleoptions(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options?: RawAxiosRequestConfig) {
        return WearPredictionScheduleOptionsApiFp(this.configuration).postWearpredictionscheduleoptions(rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a WearPredictionScheduleOption by its id
     * @summary Updates a WearPredictionScheduleOption by its id
     * @param {string} optionId Identifier of the schedule option
     * @param {RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto} [rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto] The updated schedule option
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putWearpredictionscheduleoptionsOptionid(optionId: string, rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto?: RHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options?: RawAxiosRequestConfig) {
        return WearPredictionScheduleOptionsApiFp(this.configuration).putWearpredictionscheduleoptionsOptionid(optionId, rHIMAPOReportingWearManagementApiV1ModelsWearPredictionScheduleOptionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



